/* eslint-disable no-console */
import { call, put, takeEvery, select } from 'redux-saga/effects'

import { getIpAddress } from 'models/General/selectors'
import api from './api'
import actions from './actions'
import { generatePollfishParams } from './utils'

export function* fetchPollfish({ payload }) {
  const { callback } = payload
  let isSuccess = false
  let surveys = []
  const params = generatePollfishParams()
  const ipAddress = yield select(getIpAddress)
  const baseHeaders = { 'X-Forwarded-For': ipAddress }
  try {
    const result = yield call(api.fetchExternalSurvey, '/pollfish', baseHeaders, params)
    surveys = result.surveys || surveys
    yield put(actions.fetchPollfish.success(result))
    isSuccess = true
  } catch (err) {
    console.warn('[ExternalSurveys] fetchPollfish:', err)
    yield put(actions.fetchPollfish.failure(err))
  } finally {
    if (callback) {
      yield call(callback, isSuccess, surveys)
    }
  }
}

export default function* main() {
  yield takeEvery(actions.fetchPollfish.INIT_TYPE, fetchPollfish)
}
